// extracted by mini-css-extract-plugin
export default {"fixed":"fixed__yEBR7","truncate":"truncate__zVCS8","burger":"burger__Aq2AY"};